import Validator from 'dataphi-react-components/dist/Containers/FormScreen/FormComponent/Validator'

var maxValue = function maxValue(max) {
  return function (value) {
      return !!!value ? undefined : value > max ? "Must be less then " + max : undefined;
  };
};

var minValue = function minValue(min) {
  return function (value) {
      return !!!value ? undefined : value < min ? "Must be greater then " + min : undefined;
  };
};

const formDefs = {
    closeButton: { 
        text: "Cancel", 
        className: {
            fieldClassName: "btn hsg-btn-primary col-md-2 col-sm-2 col-xs-2",
            groupClassName: "right col-md-12 col-sm-12 col-xs-12"
        }
    },
    submitButton: { 
        text: 'Save',
        className: {
            fieldClassName: "btn hsg-btn-primary col-md-2 col-sm-2 col-xs-2",
            groupClassName: "right col-md-12 col-sm-12 col-xs-12"
        }
    },
    metaData: [
      {
        name: "med_height",
        type: "number",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-6 col-sm-6 col-xs-6',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "Height",
        placeholder: "cm",
        validation: [maxValue(250), minValue(20)]
      },
      {
        name: "med_weight",
        type: "number",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-6 col-sm-6 col-xs-6',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "Weight",
        placeholder: "kg",
        validation: [maxValue(150), minValue(5)]
      },
      {
        name: "med_bp_sys",
        type: "number",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-4 col-sm-4 col-xs-4',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "BP Sys.",
        placeholder: "mg/mm",
        validation: []
      },
      {
        name: "med_bp_dia",
        type: "number",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-4 col-sm-4 col-xs-4',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "BP Dia.",
        placeholder: "mg/mm",
        validation: []
      },
      {
        name: "med_heart_rate",
        type: "number",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-4 col-sm-4 col-xs-4',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "Heart Rate",
        placeholder: "per minute",
        validation: []
      },
      {
        name: "med_body_temp",
        type: "number",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-4 col-sm-4 col-xs-4',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "Body Temprature",
        placeholder: "°c",
        validation: []
      },
      {
        name: "med_respiratory_rate",
        type: "number",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-4 col-sm-4 col-xs-4',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "Respiratory Rate",
        placeholder: "per minute",
        validation: []
      },
      {
        name: "med_complaint",
        type: "text",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "Complaints",
        placeholder: "",
        validation: [Validator.required]
      },
      {
        name: "med_symptoms",
        type: "text",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "Symptoms",
        placeholder: "",
        validation: [Validator.required]
      },
      {
        name: "med_suggestion",
        type: "text",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "Suggesions",
        placeholder: "",
        validation: [Validator.required]
      },
      {
        name: "med_remarks",
        type: "text",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "Remark",
        placeholder: "",
        validation: []
      },
      {
        name: 'med_called',
        type: 'checkbox',
        className: {
            fieldClassName: 'hsg-checkbox',
            groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
            errorClassName: 'hsg-error',
            labelClassName: 'hsg-checkbox-label'
        },
        label: 'Called?',
        placeholder: '',
        options:  [
          {
              label: 'Ambulance',
              value: 'ambulance'
          },
          {
              label: 'Parent',
              value: 'parent'
          }
        ],
        validation: []
      }
    ]
  }

  export default {
    formDefs,
    minValue,
    maxValue
  }


// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainer/Component/Episode/Source.js